import React from "react";

var caretRightSvg = function caretRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.689 14.709l6.021-6.01a.986.986 0 0 0 0-1.397L6.69 1.292C6.066.668 5 1.11 5 1.99v12.02c0 .88 1.066 1.32 1.689.699z",
    fillRule: "evenodd"
  }));
};

caretRightSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var caretRight = {
  category: 'icon',
  colorable: true,
  name: 'caretRight',
  svg: caretRightSvg
};